// react imports
import React, { useContext, useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import Swiper from "swiper";
import { FreeMode } from "swiper/modules";
// import Swiper and modules styles
import "swiper/css";

// CUSTOM COMPONENTS
import AppContext from "../../AppContext";

import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import Captions from "yet-another-react-lightbox/plugins/captions";
import Fullscreen from "yet-another-react-lightbox/plugins/fullscreen";
import Slideshow from "yet-another-react-lightbox/plugins/slideshow";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import Share from "yet-another-react-lightbox/plugins/share";
import Download from "yet-another-react-lightbox/plugins/download";
import Video from "yet-another-react-lightbox/plugins/video";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import "yet-another-react-lightbox/plugins/captions.css";
import "yet-another-react-lightbox/plugins/thumbnails.css";

const CarouselComponent = (props) => {
  //MDBAlert

  // REACT ROUTER PARAMS - for processing url
  const context = useContext(AppContext);

  // STATES
  const [videoWidht, setVideoWidht] = useState(window.innerWidth < 1920 ? window.innerWidth : 1920);
  const [starttime, setStarttime] = useState(false);
  const [isFirstStep, setIsFirstStep] = useState(true);
  const [index, setIndex] = useState(0);
  const [open, setOpen] = useState(false);
  const [videocardHeight, setVideocardHeight] = useState(
    (document.getElementById("thumbnail-image")?.clientWidth * 9) / 16,
  );

  // react router navigation
  const navigate = useNavigate();

  const responsive = {
    desktop2: {
      breakpoint: { max: 4000, min: 1920 },
      items: 5,
      partialVisibilityGutter: 3,
    },
    desktop: {
      breakpoint: { max: 1920, min: 1400 },
      items: 5,
      partialVisibilityGutter: 3,
    },
    tablet2: {
      breakpoint: { max: 1400, min: 1100 },
      items: 4,
      partialVisibilityGutter: 3,
    },
    tablet: {
      breakpoint: { max: 1100, min: 740 },
      items: 3,
      partialVisibilityGutter: 3,
    },
    small: {
      breakpoint: { max: 450, min: 0 },
      items: 2,
      partialVisibilityGutter: 1,
    },
  };

  const handleWindowSizeChange = () => {
    setVideoWidht(window.innerWidth < 1920 ? window.innerWidth : 1920);
    setVideocardHeight((document.getElementById("thumbnail-image")?.clientWidth * 9) / 16);
  };

  useEffect(() => {
    window.addEventListener("resize", handleWindowSizeChange);
    setTimeout(() => {
      setStarttime(true);
    }, 300);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);

  useEffect(() => {
    setVideocardHeight((document.getElementById("thumbnail-image")?.clientWidth * 9) / 16);
  }, [document.getElementById("thumbnail-image")?.clientWidth]);

  const swiper = new Swiper(".swiper", {
    // Optional parameters
    modules: [FreeMode],
    breakpoints: {
      // when window width is >= 320px
      320: {
        slidesPerView: 3,
        spaceBetween: 0,
      },
      // when window width is >= 480px
      600: {
        slidesPerView: 4,
        spaceBetween: 0,
      },
      // when window width is >= 640px
      760: {
        slidesPerView: 5,
        spaceBetween: 0,
      },
    },
    direction: "horizontal",
    loop: false,
    effect: "slide",
    freeMode: {
      enabled: true,
      sticky: true,
    },
  });

  const setOpenLightbox = (index) => {
    setIndex(index);
    setOpen(true);
  };

  return (
    <div className="more-carousel" style={{ height: videocardHeight + 50 }}>
      <div className="d-none d-lg-block" style={{ width: "100%" }}>
        <Carousel
          additionalTransfrom={0}
          swipeable={true}
          draggable={!window.matchMedia("(max-device-width: 740px)").matches ? false : true}
          showDots={!window.matchMedia("(max-device-width: 740px)").matches ? true : false}
          responsive={responsive}
          infinite={true}
          renderArrowsWhenDisabled={true}
          renderDotsOutside={true}
          slidesToSlide={4}
          centerMode={false}
          keyBoardControl={true}
          customTransition={
            window.matchMedia("(max-device-width: 400px)").matches
              ? "transform 100ms ease-in-out"
              : "transform 1000ms ease-in-out"
          }
          transitionDuration={window.matchMedia("(max-device-width: 400px)").matches ? 100 : 1000}
          containerClass={isFirstStep ? "carousel-container firststep" : "carousel-container"}
          removeArrowOnDeviceType={["small", "mobileclaim"]}
          dotListClass="custom-dot-list-style"
          itemClass="carousel-item-padding-40-px"
          afterChange={(previousSlide, { currentSlide, onMove }) => {
            setIsFirstStep(false);
          }}
        >
          {props.fotoList.map((k, n) => {
            return (
              <div
                className="videocard-more"
                key={n}
                id="touchsurface"
                style={{ height: videocardHeight, width: "100%" }}
              >
                <div className="background-img">
                  <img
                    src={k.thumbnailUrl}
                    alt="thumbnail-image"
                    id="thumbnail-image"
                    className="thumbnail-image"
                    onClick={() => setOpenLightbox(n)}
                  />
                </div>
              </div>
            );
          })}
        </Carousel>
      </div>
      <div className="swiper d-block d-lg-none">
        <div className="swiper-wrapper">
          {props.fotoList.map((k, n) => {
            return (
              <>
                {starttime && (
                  <div class="swiper-slide" key={n}>
                    <div className="videocard-more-respo">
                      <div className="background-img" onClick={() => setOpenLightbox(n)}>
                        <img src={k.thumbnailUrl} alt="thumbnail-image" id="thumbnail-image" />
                      </div>
                    </div>
                  </div>
                )}
              </>
            );
          })}
        </div>
      </div>
      <Lightbox
        open={open}
        close={() => setOpen(false)}
        slides={props.fotoList.map((k) => {
          return { src: k.url };
        })}
        index={index}
        plugins={[Captions, Fullscreen, Video, Zoom, Download, Share, Slideshow, Thumbnails]}
        captions={{
          hidden: false,
        }}
        styles={{
          root: { "--yarl__color_backdrop": "rgba(0, 0, 0, .9)" },
          navigationNext: {
            "--yarl__color_button": "rgba(251, 251, 251, .5)",
            "--yarl__color_button_active": "rgba(251, 251, 251, 1)",
            "--yarl__color_button_hover": "rgba(251, 251, 251, 1)",
          },
          navigationPrev: {
            "--yarl__color_button": "rgba(251, 251, 251, .5)",
            "--yarl__color_button_active": "rgba(251, 251, 251, 1)",
            "--yarl__color_button_hover": "rgba(251, 251, 251, 1)",
          },
        }}
      />
    </div>
  );
};

export default CarouselComponent;
